.errorMessage {
    padding: 10px;
}